const DEFAULT_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "/api";
const LOOPBACK_HOSTNAMES = new Set(["localhost", "127.0.0.1", "::1"]);

function normalizeBaseUrl(baseUrl) {
  if (!baseUrl) {
    return "";
  }
  return baseUrl.endsWith("/") ? baseUrl.slice(0, -1) : baseUrl;
}

function resolveApiBaseUrl() {
  const baseUrl = normalizeBaseUrl(DEFAULT_API_BASE_URL);
  if (!baseUrl) {
    return "/api";
  }

  if (typeof window === "undefined") {
    return baseUrl;
  }

  try {
    const parsedBaseUrl = new URL(baseUrl, window.location.origin);
    const isLoopbackTarget = LOOPBACK_HOSTNAMES.has(parsedBaseUrl.hostname);
    const isLoopbackCurrentOrigin = LOOPBACK_HOSTNAMES.has(window.location.hostname);

    if (isLoopbackTarget && !isLoopbackCurrentOrigin) {
      return "/api";
    }
  } catch {
    return baseUrl;
  }

  return baseUrl;
}

export function getApiBaseUrl() {
  return resolveApiBaseUrl();
}

export function getAuthToken() {
  return localStorage.getItem("adminToken");
}

export async function fetchAPI(url, options = {}) {
  const baseUrl = getApiBaseUrl();
  const fullUrl = url.startsWith("http") ? url : `${baseUrl}${url}`;

  const defaultHeaders = {
    "Content-Type": "application/json",
  };

  // Add auth token if available
  const token = options.token || getAuthToken();
  if (token) {
    defaultHeaders.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(fullUrl, {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || "API request failed");
  }

  return await response.json();
}
